module.exports = __webpack_public_path__ + "img/tumor-ablation.a308a42a.jpg";